export default "__VITE_ASSET__adAiDS6P__"